import Rule from "../../../../common/rule";

export default class PatFieldSetup extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return gameContext.triggerPAT;
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const spot = gameContext.gameConfig.spots.PATTry;
        const fieldPosition = !gameContext.homeTeamHasPossession
            ? spot
            : gameContext.getFieldLength() - spot;

        ruleContext.driveEnd = {
            isActive: true,
            endSpot: gameContext.getFieldPosition()
        };
        gameContext.setFieldPosition(fieldPosition);
    }
}
